import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig();
  const firebaseConfig = {
    apiKey: config.public.firebaseApiKey,
    authDomain: config.public.firebaseAuthDomain,
    projectId: config.public.firebaseProjectId,
    storageBucket: config.public.firebaseStorageBucket,
    messagingSenderId: config.public.firebaseMessagingSenderId,
    appId: config.public.firebaseAppId,
    measurementId: config.public.firebaseMeasurementId ?? "",
  };

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const functions = getFunctions(app, "us-central1");

  const userStore = useUserStore();
  const { signOut } = useAuth();

  await new Promise((resolve) => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const result = await callAPI("getUserInfo");
        const userInfo = result.data.user_info;
        if (userInfo.level < 90) {
          alert("KOSTA 어드민 페이지에 접근 권한이 없습니다.");
          await auth.signOut();
          return await signOut();
        }
      }

      userStore.setUser(user);
      resolve(true);
    });
  });

  async function callAPI(name: string, param?: any) {
    console.log("function name : ", name, "\nparam : ", param);
    if (process.env.NODE_ENV === "development") {
      // connectFunctionsEmulator(functions, "localhost", 5005);
    }
    const getFunction = httpsCallable(functions, name);

    const result = await getFunction(param);
    const data = result.data;
    console.log("function name : ", name, "\nresult : ", data);
    return data;
  }
  nuxtApp.provide("firebase", { app, auth, callAPI });
});
